var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c(_vm.to != null ? 'router-link' : 'a',_vm._g(_vm._b({tag:"component",class:_vm.linkClasses},'component',_vm.linkProps,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }